// extracted by mini-css-extract-plugin
module.exports = {"postsHeader":"PostsHeader_postsHeader__30yAt","back":"PostsHeader_back__wYG-S"};